import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  Box,
  CssBaseline,
  Drawer,
  Toolbar,
  Skeleton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Sidebar from "../sidebar";
import Header from "../header";
import { useLocation } from "react-router-dom";

const drawerWidth = 201;
const drawerWidthMini = 85;
const defaultBackgroundColor = "#303C54"; // Default background color for the drawer

const LayoutContainer = ({ children }) => {
  const [open, setOpen] = useState(true);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const token = useSelector((state) =>
    Boolean(state.appReducer.token.accessToken)
  );
  const isLoading = useSelector((state) => state.appReducer.isLoading);

  const { pathname: urlActual } = useLocation();

  const toggleDrawer = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Header onShow={toggleDrawer} open={open} />

      {token && isDesktop ? (
        <>
          {urlActual != "/iniciar-sesion" ? (
            <Drawer
              variant={isDesktop ? "persistent" : "temporary"}
              open={true}
              ModalProps={{ keepMounted: true }}
              sx={{
                "& .MuiDrawer-paper": {
                  width: open ? drawerWidth : drawerWidthMini,
                  boxSizing: "border-box",
                  backgroundColor: defaultBackgroundColor,
                },
              }}
            >
              <Sidebar
                onShow={() => {}}
                open={open}
                drawerWidth={drawerWidth}
                drawerWidthMini={drawerWidthMini}
                isDesktop={isDesktop}
              />
            </Drawer>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          {urlActual != "/iniciar-sesion" ? (
            <Drawer
              variant="temporary"
              open={open}
              ModalProps={{ keepMounted: true }}
              sx={{
                "& .MuiDrawer-paper": {
                  width: drawerWidth,
                  boxSizing: "border-box",
                  backgroundColor: defaultBackgroundColor,
                },
              }}
            >
              <Sidebar
                onShow={() => {
                  setOpen(false);
                }}
                open={open}
                drawerWidth={drawerWidth}
                drawerWidthMini={drawerWidth}
                isDesktop={isDesktop}
              />
            </Drawer>
          ) : (
            <></>
          )}
        </>
      )}

      {urlActual === "/iniciar-sesion" ? (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: `100%`,
          }}
        >
          <Toolbar />
          {children}
        </Box>
      ) : (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: `100%`,
            p: 3,
            marginLeft:
              token && isDesktop 
                ? (open ? `${drawerWidth}px` : `${drawerWidthMini}px`)
                : '0px',
            transition: theme.transitions.create("margin", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          }}
        >
          {/* empuja contenido bajo AppBar */}
          <Toolbar />
          {isLoading ? (
            <Skeleton variant="rectangular" width="100%" height="80vh" />
          ) : (
            children
          )}
        </Box>
      )}
    </Box>
  );
};

LayoutContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutContainer;
